var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"second-step"},[_c('FacilityContractForm',{ref:"facilityContractForm",attrs:{"hide-button":"","isGlobal":true},on:{"dialogClosed":() => {_vm.$emit('dialogClosed')},"cancelDialog":_vm.cancelDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }